export const ConsumerLoanRoutes = {
    ROOT: "/consumer-loan",
    CALCULATOR: "/consumer-loan/calculator",
    ACCOUNT_SELECTION: "/consumer-loan/account-selection",
    SUMMARY: "/consumer-loan/summary",
    SIGNING: "/consumer-loan/signing",
    REJECTED: "/consumer-loan/rejected",
    SUCCESS: "/consumer-loan/success",
    UPDATE_ADDRESS: "/consumer-loan/update-address",
};



// WEBPACK FOOTER //
// ./src/components/loan/ConsumerLoanRoutes.ts